import { render, staticRenderFns } from "./VModule.vue?vue&type=template&id=7fc1bdda&"
import script from "./VModule.vue?vue&type=script&lang=js&"
export * from "./VModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports